var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fjxmrmqgpa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#fjxmrmqgpa)",
    transform: "translate(-580 -1136)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L17.647 0 17.647 17.647 0 17.647z",
    transform: "translate(580 1136) translate(1.176 1.176)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M14.228 7.382c-.5-2.536-2.728-4.44-5.404-4.44-2.125 0-3.971 1.205-4.89 2.97C1.72 6.147 0 8.022 0 10.294c0 2.434 1.978 4.412 4.412 4.412h9.559c2.029 0 3.676-1.647 3.676-3.677 0-1.94-1.507-3.514-3.42-3.647z",
    transform: "translate(580 1136) translate(1.176 1.176)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/weather-icon.baf331f5f64e9d1afe8da35f5f00a667.svg";
export { ForwardRef as ReactComponent };